import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { ComponentBase } from 't4core';

@Component({
  selector: 'app-search',
  templateUrl: './app-search.html',
  standalone: false
})
export class AppSearchComponent extends ComponentBase implements OnInit {

  @Output() valueChange = new EventEmitter<string>();
  @Output() cleared = new EventEmitter<void>();
  @Output() enterPressed = new EventEmitter<void>();

  @ViewChild('inputRef', { static: true })
  private inputElement!: ElementRef<HTMLInputElement>;

  constructor() {
    super();
  }

  ngOnInit(): void { }

  public onInput(value: string) {
    this.valueChange.emit(value);
  }

  public clearSearch() {
    this.inputElement.nativeElement.value = '';
    this.valueChange.emit('');
    this.cleared.emit();
  }

  public getInput(): HTMLInputElement {
    return this.inputElement.nativeElement;
  }
}
